import { ComponentType } from 'react';

interface ISvgIcon extends React.SVGProps<SVGSVGElement> {
  component: ComponentType<{ className?: string }>;
}

export const SvgIcon = ({
  component: IconComponent,
  className = 'w-5 h-5',
  ...props
}: ISvgIcon) => {
  return <IconComponent className={className} {...props} />;
};
